import script from "./AIAssistant.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistant.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistant.vue?vue&type=style&index=0&id=fbe97bec&scoped=true&lang=scss"
import "./AIAssistant.vue?vue&type=style&index=1&id=fbe97bec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbe97bec"]])

export default __exports__